import styled, { css } from "styled-components"
import theme from "../theme"

const Input = styled<
  {
    modal?: boolean
    addMember?: boolean
    hasIcon?: boolean
  },
  "input"
>("input")`
  min-width: 150px;
  outline: none;
  border: 1px transparent solid;
  display: block;
  word-break: normal;
  font: inherit;
  margin: 0px;
  left: 0;
  background: transparent;
  line-height: 2rem;
  cursor: text;
  text-rendering: auto;
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  text-align: start;
  -webkit-writing-mode: horizontal-tb !important;
  -webkit-box-direction: normal;
  font-family: ${theme.fonts.tertiary};
  font-size: 1.5rem;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 0.25rem;
  width: 100%;
  color: ${theme.colors.inputText};
  background: ${theme.colors.inputBackground};
  :focus {
    cursor: text;
  }
  ::placeholder {
    color: ${theme.colors.inputPlaceholder};
  }

  ${(props: any) =>
    props.modal &&
    css`
      color: ${theme.colors.inputText};
      background: ${theme.colors.inputBackground};
      max-width: 900px;
      min-width: 150px;
      width: 100%;
    `};
  ${(props: any) =>
    props.addMember &&
    css`
      padding-left: 10px;
    `};
  ${(props: any) =>
    props.hasIcon &&
    css`
      padding-left: 35px;
    `};
`

export default Input
